import type {
  Collaboration,
  ContentDistributionGroup,
  MiniContentDistributionGroup,
  InstanceAssignmentGroup,
  User,
  CollaborationRoleEnum,
  InstanceMembership,
  ContentDistributionGroupMembership,
  InstanceAssignmentGroupMembership,
} from '@openapi'

import { InstanceMembershipRoleEnum } from '@openapi'

export type ContentDistributionGroupItem = Pick<ContentDistributionGroup, 'name'> & {
  size?: ContentDistributionGroup['size'] //Optional if we display itemType === 'user'
  id?: ContentDistributionGroup['id'] //Optional | is not needed when we create a new group
}
export type InstanceAssignmentGroupItem = Pick<InstanceAssignmentGroup, 'name'> & {
  size?: InstanceAssignmentGroup['size'] //Optional if we display itemType === 'user'
  id?: InstanceAssignmentGroup['id'] //Optional | is not needed when we create a new group
}
export type CollaborationItem =
  | (Pick<Collaboration, 'id' | 'role' | 'file'> & {
      content_distribution_group: MiniContentDistributionGroup
    })
  | (Pick<Collaboration, 'id' | 'role' | 'canvas'> & {
      content_distribution_group: MiniContentDistributionGroup
    })
  | Pick<Collaboration, 'id' | 'role' | 'file' | 'user'>
  | Pick<Collaboration, 'id' | 'role' | 'canvas' | 'user'>

export type InstanceMembershipItem =
  | (Pick<InstanceMembership, 'id'> & {
      instance_assignment_group: InstanceAssignmentGroupItem
    })
  | (Pick<InstanceMembership, 'id' | 'role'> & {
      user: Pick<User, 'id'> & { name: string }
    })
export type ContentDistributionGroupMembershipItem = Pick<ContentDistributionGroupMembership, 'id' | 'user'> & {
  content_distribution_group: ContentDistributionGroupItem
}
export type InstanceAssignmentGroupMembershipItem = Pick<InstanceAssignmentGroupMembership, 'id' | 'user'> & {
  instance_assignment_group: InstanceAssignmentGroupItem
}

export type Item =
  | CollaborationItem
  | InstanceMembershipItem
  | ContentDistributionGroupMembershipItem
  | InstanceAssignmentGroupMembershipItem

const ExtendedInstanceMembershipRoleEnum = {
  ...InstanceMembershipRoleEnum,
  ORG_GROUP_MEMBER: 'org_group_member',
} as const

export type Role =
  | (typeof ExtendedInstanceMembershipRoleEnum)[keyof typeof ExtendedInstanceMembershipRoleEnum]
  | (typeof CollaborationRoleEnum)[keyof typeof CollaborationRoleEnum]

export type CollaborationNormalized = Omit<CollaborationItem, 'content_distribution_group'> & {
  group: MiniContentDistributionGroup
  type: 'collaboration'
}
type ContentDistributionGroupMembershipNormalized = Omit<
  ContentDistributionGroupMembershipItem,
  'content_distribution_group'
> & { group: ContentDistributionGroupItem; type: 'content_distribution_group_membership' }

export type InstanceAssignmentGroupMembershipNormalized = Omit<
  InstanceAssignmentGroupMembershipItem,
  'instance_assignment_group'
> & { group: InstanceAssignmentGroupItem; type: 'instance_assignment_group_membership' }

export type InstanceMembershipNormalized = Omit<InstanceMembershipItem, 'instance_assignment_group' | 'role'> & {
  group: InstanceAssignmentGroupItem
  type: 'instance_membership'
  role: (typeof ExtendedInstanceMembershipRoleEnum)[keyof typeof ExtendedInstanceMembershipRoleEnum]
}

export type ItemNormalized =
  | CollaborationNormalized
  | ContentDistributionGroupMembershipNormalized
  | InstanceAssignmentGroupMembershipNormalized
  | InstanceMembershipNormalized

export type GroupSelectModel = ContentDistributionGroup | InstanceAssignmentGroup
export type UserSelectModel = User | InstanceMembership | Collaboration | ContentDistributionGroupMembership
